import { useEffect, useRef } from 'react';
import equal from 'fast-deep-equal';

function useDeepCompare(value) {
  const ref = useRef();
  if (!ref.current || !equal(value, ref.current)) {
    ref.current = value;
  }
  return ref.current;
}

export default function useEffectWithDeepCompare(callback, dependencies) {
  return useEffect(callback, useDeepCompare(dependencies));
}
